var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'text-align': _vm.outgoing ? 'right' : 'left'}),attrs:{"id":"message-row"}},[_c('div',{style:(_vm.style),attrs:{"id":"message"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }